import * as ActionTypes from './types.action';

export const getInitData = params => ({
  type: ActionTypes.GET_INIT_DATA_REQUESTED,
  params,
});
